// JS (comments in English)
import { Cesium3DTileset } from "cesium";
import Type from "../Types";
import { createUniqueId, showToast } from "../Utility";

// load a 3D Tiles layer and update map state
export async function load3DTiles({ url, viewerRef, setMapObjects, layerId, projectId }) {
  try {
    const viewer = viewerRef.current;

    // Load with precise 2D/Columbus projection
    const tileset = await Cesium3DTileset.fromUrl(url, {
      projectTo2D: true, // accurate placement in 2D/CV
    });

    // --- LOD and loading prefs ---
    tileset.skipLevelOfDetail = true;
    tileset.baseScreenSpaceError = 1024;
    tileset.skipScreenSpaceErrorFactor = 16;
    tileset.skipLevels = 1;
    tileset.immediatelyLoadDesiredLevelOfDetail = true;
    tileset.loadSiblings = false;
    tileset.dynamicScreenSpaceError = false;
    tileset.maximumScreenSpaceError = 1;

    tileset.preloadWhenHidden = true;
    tileset.preloadFlightDestinations = true;
    tileset.cullRequestsWhileMoving = false;
    tileset.cullWithChildrenBounds = false;
    tileset.maximumMemoryUsage = 4096;
    tileset.maximumCacheOverflowBytes = 512 * 1024 * 1024;
    tileset.foveatedScreenSpaceError = false;

    // --- Render ---
    tileset.backFaceCulling = false;
    tileset.pointCloudShading = { attenuation: false };
    tileset.clippingPlanes = undefined;

    // Add to scene
    viewer.scene.primitives.add(tileset);

    // Recenter after mode changes (prevents stale frustum issues)
    const onMorph = () => viewer.zoomTo(tileset);
    viewer.scene.morphComplete.addEventListener(onMorph);

    // Optional cleanup handle if you later remove the tileset
    tileset.___detach = () => viewer.scene.morphComplete.removeEventListener(onMorph);

    // Zoom after ready
    await tileset.readyPromise;
    viewer.zoomTo(tileset);

    // Update app state
    setMapObjects((prev) => [
      ...prev,
      {
        id: createUniqueId(),
        name: "3D Tiles",
        tileset,
        type: Type.ASSET.THREEDTILES,
        file_name: url,
        file_type: ".json",
        visible: true,
        url,
        is_edited: false,
        layer_id: layerId ? layerId : null,
        project_id: projectId ? projectId : null,
        // tools: {
        //   export: false,
        //   save: false,
        //   zoom: false,
        //   visibility: false,
        //   direction: false,
        //   setting: false,
        //   show_lanelet: false,
        //   edit: false,
        //   json_editor: false,
        //   switch_layer: false,
        //   duplicate: false,
        //   attribute_table: false,
        //   edit_style: false,
        //   label_visibility: false,
        //   label_style: false,
        //   czml_chart: false,
        //   lanelet_view: false,
        //   line_view: false,
        //   right_lane_visibility: false,
        //   hightlight_route: false,
        //   filter: false,
        //   scan_route: false,
        //   reload: false,
        // },
      },
    ]);
  } catch (e) {
    showToast("Cannot load 3D Tiles", Type.NOTIFICATION.ERROR);
    console.error("3D Tiles load error:", e);
  }
}
